import { ModBox, TextNew } from '@jfs/ui-new'
import { Image } from 'react-native'
import { DownloadFileComp } from '../../../CreateBulkEntities/UploadedFileDetails/DownloadFileComp'

const ImgPDFComponent = ({ type, imgUri, onDownloadPress }: any) => {
  console.log('ImgPDFComponent', type, imgUri)

  return (
    <>
      <ModBox height={'100%'} width={'100%'} show={(type === 'PNG' || type === 'JPG')}>
        <Image style={{ flex: 1, width: '100%', height: '100%' }} resizeMode={'contain'} source={{ uri: imgUri }} />
      </ModBox>
      <ModBox show={type === 'PDF'} height={'100%'} width={'100%'}>
        <embed type={'application/pdf'} src={imgUri} style={styles.embed} height={'100%'} width={'100%'} />
      </ModBox>
      <ModBox
        backgroundColor={'BLACK_21'}
        alignItems={'center'}
        justifyContent={'center'}
        w={'100%'}
        h={'100%'}
        show={
          !(type === 'PNG' || type === 'JPG' || type === 'PDF' || type === undefined || type?.includes('undefined'))
        }>
        <DownloadFileComp
          type={'download'}
          title={'Download File'}
          onButtonPress={onDownloadPress}
          color={'PRIMARY'}
          alignment={'center'}
          showBorder
        />
      </ModBox>
      <ModBox
        show={type === undefined || type?.includes('undefined')}
        alignItems={'center'}
        justifyContent={'center'}
        w={'100%'}
        h={'100%'}>
        <TextNew title="No Document Found" color={'BLACK_21'} fontSize={14} fontWeight={'BOLD'} />
      </ModBox>
    </>
  )
}
export { ImgPDFComponent }
const styles = {
  embed: {
    position: 'absolute',
    top: '8',
    left: '0',
  } as React.CSSProperties,
}
